var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('itinerary-include-list',{attrs:{"itinerary-id":_vm.itineraryId,"loading":_vm.loading,"include-items":_vm.items,"selected-domain":_vm.selectedDomain,"include-categories":_vm.includeCategories,"list-title":_vm.title},on:{"saveIncludes":_vm.saveIncludes,"updateDomain":_vm.updateItineraryDomain}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d7b7b08","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/itinerary/ItineraryIncludeWrapper.vue
// module id = null
// module chunks = 